
import axios from 'axios'
import { FinalizePaypaPayloadlType } from 'src/core/models'

export async function finalizePaypalPaymentAPI(payload: FinalizePaypaPayloadlType): Promise<any> {
  const transformedPayload = {
    payment_id: payload.paymentId,
    payer_id: payload.payerId
  }
  const url = '/api/v1/deposits/finalize_paypal_payment/'
  const { data } = await axios.post(url, transformedPayload)
  return data
}
